import { render } from "./DeleteClientToContact.vue?vue&type=template&id=632c696a"
import script from "./DeleteClientToContact.vue?vue&type=script&lang=js"
export * from "./DeleteClientToContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__